<template>
  <div class="card">
    <header class="header-card">
      <p>
        {{ $t('detailMateriel.tlpe.title') }}
      </p>
    </header>
    <div class="card-content columns is-multiline">
      <div class="column is-3">
        <b-field :label="$t('detailMateriel.tlpe.typeTaxation')"
                 custom-class="has-text-link mgb-5px"
                 :type="!materiel.typeTaxationTlpe.actif ? 'is-warning' : ''"
                 :message="!materiel.typeTaxationTlpe.actif ?
                   $t('detailMateriel.warning.archivedTypeTaxationTlpeSelectedAbove') : ''">
          <b-field>
            <span class="ellipsis">
              {{ materiel.typeTaxationTlpe ? materiel.typeTaxationTlpe.libelle : '' }}
            </span>
            <b-icon v-if="materiel.typeTaxationTlpe" type="is-primary" icon="information"
                    custom-size="mdi-18px"
                    @click.native="popUpInformationTarif = true"
                    class="is-cursor-pointer mgl-5px"></b-icon>
          </b-field>
        </b-field>
      </div>
      <div class="column is-3">
        <b-field :label="$t('detailMateriel.tlpe.surfaceTlpe')"
                 custom-class="has-text-link mgb-5px">
          {{ getSurfaceTlpe !== null ?
          $t('detailMateriel.tlpe.m2', { surface: getSurfaceTlpe }) : '' }}
        </b-field>
      </div>
      <div class="column is-3">
        <b-field :label="$t('detailMateriel.tlpe.surfaceTlpePerso')"
                 custom-class="has-text-link mgb-5px">
          {{ materiel.surface.surfaceTlpe !== null ? $t('detailMateriel.tlpe.m2', {
          surface: materiel.surface.surfaceTlpe }) : '' }}
        </b-field>
      </div>
    </div>
    <b-modal v-model="popUpInformationTarif" width="900px" has-modal-card class="modal">
      <informationTarifsTlpe
        :typeTaxationTlpeId="materiel.typeTaxationTlpeId"
        :surfaceTlpe="materiel.surface.surfaceTlpe !== null
        ? materiel.surface.surfaceTlpe : getSurfaceTlpe"
        :surfaceCommerciale="materiel.surface.surfaceCommerciale !== null
        ? materiel.surface.surfaceCommerciale : getSurfaceCommerciale">
      </informationTarifsTlpe>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import informationTarifsTlpe from '@/components/gabed/materiel/p_informationTarifsTlpe';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import { getAll as getAllTypeTaxationTlpe } from '@/api/typeTaxationTlpe';
import { NO_PAGINATION } from '@/configuration/clientTableConf';

const Parametres = createNamespacedHelpers('parametres');
const Societe = createNamespacedHelpers('societe');

export default {
  name: 'MaterielDetailTLPE',
  components: {
    informationTarifsTlpe,
  },
  data() {
    return {
      popUpInformationTarif: false,
      typeTaxeTlpeList: [],
    };
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    materielFormat() {
      return this.parametre(PARAMETRES_KEYS.materielFormat);
    },
    getSurfaceTlpe() {
      const formatFind = this.materielFormat.find((materielFormat) => {
        return materielFormat.id === this.materiel.formatId;
      });
      return formatFind ? formatFind.surface.surfaceTlpe : null;
    },
    getSurfaceCommerciale() {
      const formatFind = this.materielFormat.find((materielFormat) => {
        return materielFormat.id === this.materiel.formatId;
      });
      return formatFind ? formatFind.surface.surfaceCommerciale : null;
    },
  },
  props: {
    materiel: {
      type: Object,
      required: true,
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.typeTaxeTlpeList = (await getAllTypeTaxationTlpe({
        query: { societeId: this.societeActiveId, auto: '' },
        limit: NO_PAGINATION,
      })).data.result.items;
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
